import { PrintCopyType } from "../../../types/customer.type";

export interface CopyTypeOption {
  key: PrintCopyType;
  label: string;
  short: string;
}

// Copy types A/B = สำเนา (copies), C/D = ต้นฉบับ (originals) (fixed order).
// `label` is the full document name (matches the PWA's printed titles exactly);
// `short` is the compact ต้นฉบับ/สำเนา tag used in chips.
export const COPY_TYPES: CopyTypeOption[] = [
  { key: "A", label: "สำเนาใบกำกับภาษี/ใบส่งสินค้า/ใบแจ้งหนี้", short: "สำเนา" },
  { key: "B", label: "สำเนาใบเสร็จรับเงิน/ใบส่งสินค้า/สำเนาใบกำกับภาษี", short: "สำเนา" },
  { key: "C", label: "ต้นฉบับใบกำกับภาษี/ใบส่งสินค้า/ใบแจ้งหนี้", short: "ต้นฉบับ" },
  { key: "D", label: "ต้นฉบับใบเสร็จรับเงิน", short: "ต้นฉบับ" },
];

// An e-Tax shop (customer `etax_enabled`) receives its tax invoice electronically, so the
// backend prints it only one copy (A) and one original (C), titled without "ใบกำกับภาษี"
// — the same titles the PWA prints on its paper.
const ETAX_COPY_TITLES: Partial<Record<PrintCopyType, string>> = {
  A: "สำเนาใบส่งสินค้า / ใบแจ้งหนี้",
  C: "ต้นฉบับใบส่งสินค้า / ใบแจ้งหนี้",
};

const ETAX_COPY_TYPES: CopyTypeOption[] = COPY_TYPES.flatMap((copyType) => {
  const label = ETAX_COPY_TITLES[copyType.key];
  return label ? [{ ...copyType, label }] : [];
});

// Each e-Tax copy prints exactly once.
export const ETAX_COPY_QUANTITY = 1;

// The copy types a shop's bills print, in fixed A→D order and titled as they print.
export const getCopyTypes = (isEtaxShop: boolean): CopyTypeOption[] =>
  isEtaxShop ? ETAX_COPY_TYPES : COPY_TYPES;
